import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';

import { TranslateService } from '@ngx-translate/core';
import { FormFieldComponent } from '@pishgamrayan/ng-form-kit';
import { UserSessionService } from 'src/app/core/services/authentication/user-session.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { TranslationModule } from 'src/app/i18n';
import { ListGroupItemModule } from 'src/app/shared/global/list-group-item/list-group-item.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { EmojiPickerComponent } from '../../emoji-picker/emoji-picker.component';
import { SelectSearchModule } from '../../select-search/select.search.module';
import { SmsTemplateModalModule } from '../../sms-template-modal/sms-template-modal.module';
import { SmsBodyComponent } from '../sms-body.component';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InlineSVGModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    EmojiPickerComponent,
    ReactiveFormsModule,
    TranslationModule,
    SmsTemplateModalModule,
    SelectSearchModule,
    ListGroupItemModule,
    FormFieldComponent,
  ],
})
export class BodyComponent extends SmsBodyComponent implements OnInit {
  @Input() type: any;

  constructor(
    protected utilityService: UtilityService,
    protected dialogService: DialogService,
    protected userSession: UserSessionService,
    protected smartSmsShareMemory: SmartSmsShareMemoryService,
    protected renderer: Renderer2,
    protected translateService: TranslateService
  ) {
    super(
      utilityService,
      dialogService,
      userSession,
      smartSmsShareMemory,
      renderer,
      translateService
    );
  }
}
